import { useState } from 'react'
import { format } from 'date-fns'
import { useCreatePickingListLineMutation } from './queries/picking_lists'

export type PickingListLineItemOption = { value?: number; label?: string }

export type PickingListLineValues = {
  date: string
  item: PickingListLineItemOption
  quantity: string | number
}

export default function usePickingListLineFormController(jobId: string, initialItem: PickingListLineItemOption = {}) {
  const initialValues: PickingListLineValues = {
    date: format(new Date(), 'yyyy-MM-dd'),
    item: initialItem,
    quantity: 0,
  }
  const [values, setValues] = useState(initialValues)
  const mutation = useCreatePickingListLineMutation()

  const reset = () => {
    mutation.reset()
    setValues(initialValues)
  }

  const submit = (callback: () => void) => {
    mutation.mutate(
      {
        job_id: jobId,
        item_id: values.item.value,
        date: values.date,
        quantity: values.quantity,
      },
      {
        onSuccess: () => {
          setValues(initialValues)
          callback()
        },
      }
    )
  }

  const quantity = Number(values.quantity)
  const isSubmitDisabled =
    values.item.value === undefined || !values.date || !Number.isFinite(quantity) || quantity === 0

  const { isLoading, isError, error } = mutation
  return { values, setValues, submit, reset, isError, isLoading, error, isSubmitDisabled }
}
